// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__CvbdL","description":"MealItem_description__JFANR","price":"MealItem_price__V39eW"};